import Media from './components/Media';

const ArrivalDetails = ({ data }) => {
  return (
    <div className="flex justify-between flex-col gap-3 h-full font-roboto">
      {data.map((el, i) => {
        return el.content ? <Media {...el} key={i} /> : null;
      })}
    </div>
  );
};

export default ArrivalDetails;
